<!-- Copyright 2023 Midas Healthcare Solutions - All Rights Reserved -->
<mat-form-field class="example-chip-list" appearance="fill" *transloco="let t">
  <mat-label>{{ t('Filter by VIEW') }}</mat-label>
  <mat-chip-grid #chipGrid>
    <mat-chip-row *ngFor="let cart of items" (removed)="remove(cart)">
      {{ cart.name }}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
  </mat-chip-grid>
  <input
    #searchInput
    [formControl]="searchCtrl"
    [matChipInputFor]="chipGrid"
    [matAutocomplete]="auto"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
  />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let cart of filteredItems | async" [value]="cart">
      {{ cart.name }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
